import { composeThemeFromProps, Compose } from '@css-modules-theme/react';
import clsx from 'clsx';
import { forwardRef, useMemo } from 'react';
import defaultStyles from './styles/Col.module.scss.js';
import { jsx } from 'react/jsx-runtime';
import { isNumber, isObject } from '../../utils/is.js';

function getFlexString(flex) {
  if (typeof flex === 'string' && /\d+[px|%|em|rem|]{1}/.test(flex)) {
    return `0 0 ${flex}`;
  }
  return flex;
}
const Col = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    theme,
    style,
    children,
    span = 24,
    offset,
    order,
    pull,
    push,
    xs,
    sm,
    md,
    lg,
    xl,
    xxl,
    flex,
    variant = 'nogutter',
    ...rest
  } = props;
  const styles = composeThemeFromProps(defaultStyles, {
    theme
  }, {
    compose: Compose.Merge
  });
  function adaptationGrid() {
    const screenList = {
      xs,
      sm,
      md,
      lg,
      xl
    };
    let responsiveClasses = '';
    Object.keys(screenList).forEach(screen => {
      const screenValue = screenList[screen];
      if (isNumber(screenValue)) {
        if (screenValue >= 0) {
          responsiveClasses += clsx({
            [styles[`col_${screen}-${screenValue}`]]: true
          });
        }
      } else if (isObject(screenValue)) {
        responsiveClasses += clsx(' ', {
          [styles[`col_${screen}_span_${screenValue.span}`]]: screenValue.span,
          [styles[`col_${screen}_offset_${screenValue.offset}`]]: screenValue.offset,
          [styles[`col_${screen}_order_${screenValue.order}`]]: screenValue.order,
          [styles[`col_${screen}_pull_${screenValue.pull}`]]: screenValue.pull,
          [styles[`col_${screen}_push_${screenValue.push}`]]: screenValue.push,
          [styles[`col_${screen}_variant_${screenValue.variant}`]]: screenValue.variant
        });
      }
    });
    return responsiveClasses;
  }
  const isWithoutMobileRules = !xs && !sm && !md && !lg && !xl && !xxl;
  let colClassNames = clsx(styles.col, {
    [styles[`col_order_${order}`]]: order,
    [styles[`col_span_${span}`]]: span && isWithoutMobileRules,
    [styles[`col_offset_${offset}`]]: offset,
    [styles[`col_pull_${pull}`]]: pull,
    [styles[`col_push_${push}`]]: push,
    [styles[`col_variant_${variant}`]]: variant
  });
  colClassNames += clsx(adaptationGrid());
  const flexStyle = useMemo(() => getFlexString(flex) ? {
    flex: getFlexString(flex)
  } : {}, [flex]);
  return /*#__PURE__*/jsx("div", {
    ref: ref,
    ...rest,
    style: {
      ...style,
      ...flexStyle
    },
    className: colClassNames,
    children: children
  });
});
Col.displayName = 'Col';

export { Col };
